let code = 'osgestao';
let codeAPI = 'os';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};